import React, {FC, useEffect, useState} from 'react'
import type {DefectRecord} from '../core/_models'

type Props = {
  record: DefectRecord | null
  loading: boolean
  onClose: () => void
  onSave: (remarks: string) => Promise<void>
}

export const DefectOfficeReviewModal: FC<Props> = ({record, loading, onClose, onSave}) => {
  const [remarks, setRemarks] = useState('')
  const [error, setError] = useState('')
  useEffect(() => {
    setRemarks(record?.officeRemarks || '')
    setError('')
  }, [record])
  if (!record) return null
  return (
    <div className='modal d-block' style={{background: 'rgba(0,0,0,0.5)', zIndex: 2100}}
      role='dialog' aria-modal='true' aria-labelledby='defect-office-review-title'>
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <div>
              <h5 id='defect-office-review-title' className='modal-title'>Office Review - Defect</h5>
              <div className='text-muted small mt-1'>{record.defectNumber || '-'} | {record.vesselName || '-'}</div>
            </div>
            <button type='button' className='btn-close' aria-label='Close' disabled={loading} onClick={onClose} />
          </div>
          <div className='modal-body'>
            <label htmlFor='defect-office-remarks' className='form-label fw-semibold'>
              Office Remarks <span className='text-danger'>*</span>
            </label>
            <textarea id='defect-office-remarks' className='form-control' rows={5}
              placeholder='Add office review remarks' maxLength={10000} value={remarks} disabled={loading}
              onChange={event => {setRemarks(event.target.value); setError('')}} />
            {error && <div className='text-danger mt-2' role='alert'>{error}</div>}
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light btn-sm' disabled={loading} onClick={onClose}>Cancel</button>
            <button type='button' className='btn btn-primary btn-sm' disabled={loading} onClick={() => {
              if (!remarks.trim()) {setError('Office remarks are required.'); return}
              void onSave(remarks.trim())
            }}>{loading ? 'Submitting...' : 'Submit Office Review'}</button>
          </div>
        </div>
      </div>
    </div>
  )
}
